import React from "react";
import styled from "styled-components";
import { breakpoints, colors } from "../../../../theme";

// styles
const HighlightsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.5rem;
  margin-bottom: 40px;

  @media (min-width: ${breakpoints.desktop}) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

const HighlightCard = styled.section`
  background: ${colors.surface};
  border: 1px solid ${colors.form.border};
  border-radius: 12px;
  padding: 1.5rem;
`;

const CardIcon = styled.div`
  width: 3rem;
  height: 3rem;
  margin-bottom: 1rem;

  svg {
    width: 100%;
    height: 100%;
  }
`;

const CardTitle = styled.h3`
  margin-bottom: 0.5rem;
  font-weight: 600;
  font-size: 1rem;
  color: ${colors.blue800};
`;

const CardText = styled.p`
  margin: 0;
  font-size: 0.875rem;
  color: ${colors.blue800};
`;

function Highlight({ icon, title, children }) {
  return (
    <HighlightCard>
      <CardIcon>{icon}</CardIcon>
      <CardTitle>{title}</CardTitle>
      <CardText>{children}</CardText>
    </HighlightCard>
  );
}

export default function Highlights() {
  return (
    <HighlightsGrid id="Availability">
      <Highlight
        title="Availability"
        icon={
          <svg
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M23.5 46.5C35.6503 46.5 45.5 36.6503 45.5 24.5C45.5 12.3497 35.6503 2.5 23.5 2.5C11.3497 2.5 1.5 12.3497 1.5 24.5C1.5 36.6503 11.3497 46.5 23.5 46.5Z"
              stroke={colors.linkHover.light}
              stroke-miterlimit="10"
            ></path>
            <path
              d="M23.5 27V8"
              stroke={colors.linkHover.light}
              stroke-miterlimit="10"
            ></path>
            <path
              d="M21 24.5H34"
              stroke={colors.linkHover.light}
              stroke-miterlimit="10"
            ></path>
            <path
              d="M23.5 8V5"
              stroke={colors.linkHover.light}
              stroke-miterlimit="10"
            ></path>
            <path
              d="M23.5 44V41"
              stroke={colors.linkHover.light}
              stroke-miterlimit="10"
            ></path>
            <path
              d="M40 24.5H43"
              stroke={colors.linkHover.light}
              stroke-miterlimit="10"
            ></path>
            <path
              d="M4 24.5H7"
              stroke={colors.linkHover.light}
              stroke-miterlimit="10"
            ></path>
          </svg>
        }
      >
        Full-time
      </Highlight>

      <Highlight
        title="Preferred environment"
        icon={
          <svg
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M43.5 4.5H4.5C3.39543 4.5 2.5 5.39543 2.5 6.5V32.5C2.5 33.6046 3.39543 34.5 4.5 34.5H43.5C44.6046 34.5 45.5 33.6046 45.5 32.5V6.5C45.5 5.39543 44.6046 4.5 43.5 4.5Z"
              stroke={colors.linkHover.light}
              stroke-miterlimit="10"
            ></path>
            <path
              d="M14 45.5H34"
              stroke={colors.linkHover.light}
              stroke-miterlimit="10"
            ></path>
            <path
              d="M19.5 42V35"
              stroke={colors.linkHover.light}
              stroke-miterlimit="10"
            ></path>
            <path
              d="M28.5 42V35"
              stroke={colors.linkHover.light}
              stroke-miterlimit="10"
            ></path>
            <path
              d="M3 28.5H45"
              stroke={colors.linkHover.light}
              stroke-miterlimit="10"
            ></path>
          </svg>
        }
      >
        React, Next.js, TypeScript, Web components, AWS, Redux
      </Highlight>

      <Highlight
        title="The most amazing..."
        icon={
          <svg
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M23 2L29.34 14.84L43.5 16.9L33.25 26.89L35.67 41L23 34.34L10.33 41L12.75 26.89L2.5 16.9L16.66 14.84L23 2Z"
              stroke={colors.linkHover.light}
              stroke-miterlimit="10"
            ></path>
            <path
              d="M23 47.5C24.933 47.5 26.5 45.933 26.5 44C26.5 42.067 24.933 40.5 23 40.5C21.067 40.5 19.5 42.067 19.5 44C19.5 45.933 21.067 47.5 23 47.5Z"
              stroke={colors.linkHover.light}
              stroke-miterlimit="10"
            ></path>
            <path
              d="M43 33.5C44.933 33.5 46.5 31.933 46.5 30C46.5 28.067 44.933 26.5 43 26.5C41.067 26.5 39.5 28.067 39.5 30C39.5 31.933 41.067 33.5 43 33.5Z"
              stroke={colors.linkHover.light}
              stroke-miterlimit="10"
            ></path>
            <path
              d="M4 33.5C5.933 33.5 7.5 31.933 7.5 30C7.5 28.067 5.933 26.5 4 26.5C2.067 26.5 0.5 28.067 0.5 30C0.5 31.933 2.067 33.5 4 33.5Z"
              stroke={colors.linkHover.light}
              stroke-miterlimit="10"
            ></path>
            <path
              d="M11 10.5C12.933 10.5 14.5 8.933 14.5 7C14.5 5.067 12.933 3.5 11 3.5C9.067 3.5 7.5 5.067 7.5 7C7.5 8.933 9.067 10.5 11 10.5Z"
              stroke={colors.linkHover.light}
              stroke-miterlimit="10"
            ></path>
            <path
              d="M36 10.5C37.933 10.5 39.5 8.933 39.5 7C39.5 5.067 37.933 3.5 36 3.5C34.067 3.5 32.5 5.067 32.5 7C32.5 8.933 34.067 10.5 36 10.5Z"
              stroke={colors.linkHover.light}
              stroke-miterlimit="10"
            ></path>
          </svg>
        }
      >
        Architected a complex React/Next.js redesign that cut load times by 40%
        and doubled engagement.
      </Highlight>
    </HighlightsGrid>
  );
}
